import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import axios from 'axios'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { DeviceLinksDto } from '../api/dto'
import { DeviceLinkModel } from '../models'
import { deviceLinksDtoToModelTransformer } from '../api/transformer'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { isEmpty } from 'lodash'

interface UseDeviceLinksHook {
  getDeviceLinks: (installationId: number, usedecommissionedAtCondition?: boolean) => Promise<ApiResult<DeviceLinkModel[]>>
}

const useDeviceLinks = (): UseDeviceLinksHook => {
  const authFetch = useAuthFetchWithResponse()
  const { t } = useCustomTranslation()
  const { enqueueErrorStack } = useSnackbar()

  const getDeviceLinks = async (installationId: number, usedecommissionedAtCondition = true): Promise<ApiResult<DeviceLinkModel[]>> => {
    let deviceLinksPath = `installations/${installationId}/device-links`
    if (usedecommissionedAtCondition === false) {
      deviceLinksPath += '?decommissionedAtCondition=false'
    }

    const deviceLinks = await authFetch<DeviceLinksDto>({
      path: deviceLinksPath,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })
      .then(response => {
        if (response.status === StatusCodes.OK) {
          const transformedDeviceLinks = !isEmpty(response.data) ? deviceLinksDtoToModelTransformer(response.data) : []
          return new ApiResult<DeviceLinkModel[]>(transformedDeviceLinks, false)
        }
        return new ApiResult<DeviceLinkModel[]>([], true)
      })
      .catch(err => {
        if (!axios.isAxiosError(err)) throw err
        const error = err as AuthFetchError
        console.error(err)
        if (error.status === StatusCodes.FORBIDDEN) {
          enqueueErrorStack(t('dashboard.errors.installation-device-links-fetch-forbidden'))
        } else {
          enqueueErrorStack(t('dashboard.errors.installation-device-links-fetch'), error.code, error.message)
        }
        return new ApiResult<DeviceLinkModel[]>([], true)
      })
    return deviceLinks
  }

  return { getDeviceLinks }
}

export default useDeviceLinks
